import { useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import LandingPage from "@/pages/LandingPage";
import TrialRegisterPage from "@/pages/TrialRegisterPage";
import TermsOfLicensePage from "@/pages/TermsOfLicensePage";
import LicenciamentoRenovacoesPage from "@/pages/LicenciamentoRenovacoesPage";
import AdminLeadsPage from "@/pages/AdminLeadsPage";
import ConfirmacaoPagamentoPage from "@/pages/ConfirmacaoPagamentoPage";
import ConhecimentoHubPage from "@/pages/ConhecimentoHubPage";
import ConhecimentoArticlePage from "@/pages/ConhecimentoArticlePage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/trial-register" element={<TrialRegisterPage />} />
          <Route path="/termos-de-licenca" element={<TermsOfLicensePage />} />
          <Route path="/licenciamento-renovacoes" element={<LicenciamentoRenovacoesPage />} />
          <Route path="/admin/leads" element={<AdminLeadsPage />} />
          <Route path="/confirmacao-pagamento" element={<ConfirmacaoPagamentoPage />} />
          <Route path="/conhecimento" element={<ConhecimentoHubPage />} />
          <Route path="/conhecimento/:slug" element={<ConhecimentoArticlePage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
